import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {User} from "../../../objects/user";
import {ListItem} from "../../../objects/listItem";
import {ListingModel} from "../../../objects/listing-model";
import {SubscriptionLike} from "rxjs";
import {AppComponent} from "../../../app.component";
import {MobileContainerComponent} from "../mobile-container/mobile-container.component";
import {MatDialog} from "@angular/material/dialog";
import {SharedDataService} from "../../../services/shared-data.service";
import {environment} from "../../../../environments/environment";
import {AppEvent} from "../../../objects/appEvent";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";

@Component({
  selector: 'app-trainer-details',
  templateUrl: './trainer-details.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class TrainerDetailsComponent implements OnInit {

  state: string = 'loading';
  errMsg: string = '';
  profile: User;
  trainerItem: ListItem;
  listing: ListingModel;
  typicalItemHeight = 80;

  @Input() viewID: string; //before component init
  private sharedEventSubscription: SubscriptionLike; //user refresh after component init

  constructor(public application: AppComponent,
              public mobileContainer: MobileContainerComponent,
              public dialog: MatDialog,
              public confirmationDialog: MatDialog,
              private sharedDataService: SharedDataService,) { }

  ngOnInit(): void {
    this.listing = new ListingModel();
    this.itemViewPicked(this.viewID)
  }
  ngOnDestroy() {
    //this.sharedEventSubscription.unsubscribe();
  }

  private itemViewPicked(itemID) {
    this.state = 'loading';

    this.application.apiService.getProfileEvents(environment['gid'],itemID,environment['g_hash'],'training_add')
      .subscribe(
        data => this.handleItems(data),
        error => this.handleItemsError(error))
  }

  private proFileEventsData:object;
  private handleItems(data) {
    this.proFileEventsData = data;
    this.profile = this.proFileEventsData['profile'] as User;
    let calendarItems;

    switch (this.mobileContainer.state) {
      //case 'trainer_booking':
      case 'trainer_view':
        this.trainerItem = this.application.apiService.extractProfilesData([this.profile],'trainer')[0];
        calendarItems = this.application.apiService.extractClubEventsData(this.proFileEventsData['events']);
        this.state = 'booking_calendar';
        this.typicalItemHeight = 80;
        break;
    }

    //let appEvent = new AppEvent(AppEvent.SELECTED_USER_LOADED, eventData);
    //this.sharedDataService.pushAppEvent(appEvent)
  }
  private handleItemsError(error) {
    this.state = 'error';
    this.errMsg = error.errMsg;
  }

}
